export default __webpack_public_path__ + "static/media/cloud-service.8f79eb22.jpeg";